// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"pause"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M11 17L11 7H8V17H11Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16 17L16 7H13L13 17H16Z"},"nodeName":"path","children":[]}]}]};

@tag('t-icon-pause')
export default class PauseIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'pause',
    }
  }
}
